import React, { Component } from 'react'
import serviceIllust01 from '../../assets/images/service/animated-system.png';
import serviceIllust02 from '../../assets/images/service/animated-package1.png';
import serviceIllust03 from '../../assets/images/service/animated-support.png';
import serviceIllust04 from '../../assets/images/service/animated-infra.png';

export default class ServiceSection extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="container-box" id="home-service-container">
                    <div className="row row-title">
                        <div className='col col-hr'><hr></hr></div>
                        <div className='col-12 col-md-6 col-lg-4'>
                            <h1 className="text-blue">サービス内容</h1>
                            <h5>SERVICES</h5>
                        </div>
                        <div className='col col-hr'><hr></hr></div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 service-title">
                            <h1>よりしなやかに、よりフレキシブルに。グローバルスタンダードの生産管理システムを創造</h1>
                            <p>
                                お客様のニーズに合わせたシステムの実現に向けてクオリティの高い技術の提供を。 
                                弊社ではお客様のご要望を正確に把握し、システムのご提案から「開発・導入・運用保守」
                                までを責任を持って対応します。 また受託・派遣の両面での「技術提供」も積極的に行っております。
                                製造業・流通業で実績を重ね、さらなる可能性に挑み続けるシステム開発のスペシャリスト集団、
                                それが私たちです。
                            </p>
                        </div>
                        <div className="col-12 col-sm-6 col-xl-3 mt-3 service-card">
                            <div className="service-card-outer">
                                <div className="service-badge"><i className="fa fa-desktop fa-2x"></i></div>
                                <div className="service-card-inner-container">
                                    <div className="service-card-img">
                                        <img src={serviceIllust01} alt="service-illustration" className="service-img" />
                                    </div>
                                    <div className="service-card-title">
                                        <h2>システム開発</h2>
                                    </div>
                                    <div className="service-card-content">
                                        お客様のニーズを正確に把握し、システム提案から開発・導入・保守までを行います。
                                    </div>
                                    <div className="service-card-btn">
                                        <a href="/service#system-container">一覧を見る</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-xl-3 mt-3 service-card">
                            <div className="service-card-outer">
                                <div className="service-badge"><i className="fa fa-folder-open fa-2x"></i></div>
                                <div className="service-card-inner-container">
                                    <div className="service-card-img">
                                        <img src={serviceIllust02} alt="service-illustration" className="service-img" />
                                    </div>
                                    <div className="service-card-title">
                                        <h2>パッケージ開発・導入</h2>
                                    </div>
                                    <div className="service-card-content">
                                        弊社オリジナルのパッケージ商品を販売。他社商品の導入サポートも承ります。    
                                    </div>
                                    <div className="service-card-btn">
                                        <a href="/service#package-container">一覧を見る</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-xl-3 mt-3 service-card">
                            <div className="service-card-outer">
                                <div className="service-badge"><i className="fa fa-users fa-2x"></i></div>
                                <div className="service-card-inner-container">
                                    <div className="service-card-img">
                                        <img src={serviceIllust03} alt="service-illustration" className="service-img" />
                                    </div>
                                    <div className="service-card-title">
                                        <h2>技術支援</h2>
                                    </div>
                                    <div className="service-card-content">
                                        システム開発における人材派遣を行います。検討段階からの技術者派遣も可能です。
                                    </div>
                                    <div className="service-card-btn">
                                        <a href="/service#tech-container">一覧を見る</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-xl-3 mt-3 service-card">
                            <div className="service-card-outer">
                                <div className="service-badge"><i className="fa fa-sitemap fa-2x"></i></div>
                                <div className="service-card-inner-container">
                                    <div className="service-card-img">
                                        <img src={serviceIllust04} alt="service-illustration" className="service-img" />
                                    </div>
                                    <div className="service-card-title">
                                        <h2>インフラ構築</h2>
                                    </div>
                                    <div className="service-card-content">
                                        お客様の現在の状況、資産を有効利用し、低コストでシンクライアント環境を実現します。
                                    </div>
                                    <div className="service-card-btn">
                                        <a href="/service#infra-container">一覧を見る</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
